import React, { useState, useEffect } from "react";

const formatClock = (d) =>
  d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

const Cellular = () => (
  <svg viewBox="0 0 18 12" aria-hidden="true" className="status-glyph">
    {[0, 1, 2, 3].map((i) => (
      <rect
        key={i}
        x={i * 4.5}
        y={9 - i * 2.6}
        width="3"
        height={3 + i * 2.6}
        rx="1"
        fill="currentColor"
        opacity={i === 3 ? 0.4 : 1}
      />
    ))}
  </svg>
);

const Wifi = () => (
  <svg viewBox="0 0 16 12" aria-hidden="true" className="status-glyph">
    <path d="M8 10.4l2.1-2.6a3.2 3.2 0 0 0-4.2 0z" fill="currentColor" />
    <path
      d="M3.4 5.4a7 7 0 0 1 9.2 0M1 2.6a10.6 10.6 0 0 1 14 0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const Battery = () => (
  <svg viewBox="0 0 26 12" aria-hidden="true" className="status-glyph">
    <rect
      x="0.7"
      y="0.7"
      width="21"
      height="10.6"
      rx="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      opacity="0.55"
    />
    <rect x="2.4" y="2.4" width="15" height="7.2" rx="1.8" fill="currentColor" />
    <path d="M23.4 4.2v3.6a2 2 0 0 0 0-3.6z" fill="currentColor" opacity="0.55" />
  </svg>
);

/**
 * The strip along the top of every phone screen.
 *
 * The clock stays empty until mount on purpose. Seeding it with the current
 * time bakes the build-time string into the server HTML and mismatches on
 * hydration, which React reports as errors 418 and 425.
 */
const StatusBar = () => {
  const [clock, setClock] = useState("");

  useEffect(() => {
    const tick = () => setClock(formatClock(new Date()));
    tick();
    const id = setInterval(tick, 20000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="status-bar">
      <span className="status-time">{clock}</span>
      <span className="status-icons">
        <Cellular />
        <Wifi />
        <Battery />
      </span>
    </div>
  );
};

export default StatusBar;
